/* eslint-disable @typescript-eslint/camelcase */
import { LoanStatusEnum } from "@toorak/tc-common-util-sdk";
import { LoanStage, UserRole } from "@toorak/tc-common-fe-sdk";
import { isRole } from "./AccessManagement";
// Query related constants

// Data Entry loans stay hidden in the loan list only for LAT Treasurer;
// all other LAT users can see them. Excel Error/submit stay hidden for everyone.
const latHiddenLoanStates = () =>
  isRole(UserRole.LAT_TREASURER)
    ? [
        LoanStatusEnum.DataEntry,
        LoanStatusEnum.ExcelError,
        LoanStatusEnum.Submit
      ]
    : [LoanStatusEnum.ExcelError, LoanStatusEnum.Submit];
export const appendToQueryForLATToggle = (val1?: any) => {
  const preToggle = {
    terms: {
      "loan.loanStage.raw": [LoanStage.fes]
    }
  };
  const allToggle = {
    bool: {
      must: [
        {
          terms: {
            "loan.loanStage.raw": [LoanStage.fes]
          }
        },
        {
          terms: {
            "loan.loanState.raw": [
              LoanStatusEnum.DataEntry,
              LoanStatusEnum.ExcelError
            ]
          }
        }
      ]
    }
  };
  return val1 === 2 ? preToggle : allToggle;
};

export const appendToQueryForLAT1 = () => ({
  bool: {
    must: [
      {
        terms: {
          "loan.loanStage.raw": [LoanStage.pre]
        }
      },
      {
        terms: {
          "loan.loanState.raw": latHiddenLoanStates()
        }
      },
      {
        terms: {
          "loan.loanCreatedStage.raw": [LoanStage.pre]
        }
      }
    ]
  }
});

export const appendToQueryForLAT2 = () => ({
  bool: {
    must: [
      {
        terms: {
          "loan.loanStage.raw": [LoanStage.post]
        }
      },
      {
        terms: {
          "loan.loanState.raw": latHiddenLoanStates()
        }
      },
      {
        terms: {
          "loan.loanCreatedStage.raw": [LoanStage.post]
        }
      }
    ]
  }
});

export const noOnHoldQuery = {
  bool: {
    should: [
      {
        terms: {
          "loan.onHoldBy.raw": ["NONE"]
        }
      },
      {
        bool: {
          must_not: {
            exists: {
              field: "loan.onHoldBy"
            }
          }
        }
      }
    ]
  }
};

export const onHoldQuery = {
  bool: {
    must: {
      exists: {
        field: "loan.onHoldBy"
      }
    },
    must_not: {
      terms: {
        "loan.onHoldBy.raw": ["NONE"]
      }
    }
  }
};

export const discrepanciesCountFilterOptions = [
  { key: "0-10" },
  { key: "11-25" },
  { key: ">25" }
];

const discrepanciesCountFilterRanges: {
  [key: string]: { gte: number; lte?: number };
} = {
  "0-10": { gte: 0, lte: 10 },
  "11-25": { gte: 11, lte: 25 },
  ">25": { gte: 26 }
};

export const getDiscrepanciesCountRangeQuery = (
  field: string,
  selections: string[]
) => {
  const rangeQueries = (selections || [])
    .filter((selection) => discrepanciesCountFilterRanges[selection])
    .map((selection) => ({
      range: { [field]: discrepanciesCountFilterRanges[selection] }
    }));
  if (!rangeQueries.length) return null;
  return rangeQueries.length === 1
    ? rangeQueries[0]
    : { bool: { should: rangeQueries } };
};
